export const types = {

    authLogin: '[Auth] Login',
    authlogout: '[Auth] Logout',


    //print
    printSetDate: '[Print] set Date',
    printClear: '[Print] clear Report',

    //gis
    gisSetPoint: '[Gis] set Point',
    clearPoint: '[Gis] clear Point',
}